var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"py-1 px-2 border-b border-app-0",class:{ active: _vm.active }},[_c('div',{staticClass:"flex flex-row"},[_c('span',{staticClass:"flex-grow truncate mr-1"},[_vm._v(_vm._s(_vm.message))])]),_c('div',{staticClass:"submessage text-xs"},[_vm._v(" "+_vm._s(_vm.submessage)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }